import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { TextField, Autocomplete } from '@mui/material';
import { useStyles } from './styles';
import useSelectedOption from '../../../../utils/hooks/useSelectedOption';
import getIsError from '../../../../utils/helper_functions/getIsError';
import getErrorMessage from '../../../../utils/helper_functions/getErrorMessage';
import { inputDataCustom } from '../../../../utils/custom_prop_types/customPropTypes';

export default function CornerPostSection({
  fetchProductsBySection,
  cornerPosts,
  inputData,
  setInputDataToSend,
  validation,
}) {
  const [cornerPostsArray, setCornerPostsArray] = useState([]);
  const classes = useStyles();
  const selectedOption = useSelectedOption(cornerPostsArray, inputData.cornerPostIRI);

  const handleCornerPostSelectChange = (cornerPost) => {
    const selectedProductGroup = cornerPost.value;
    const cornerPostIRI = cornerPost.iri;
    fetchProductsBySection({
      section: 'accessory',
      color: inputData.color,
      cornerPostGroup: selectedProductGroup,
      isCorner: true,
    });

    setInputDataToSend('cornerPostIRI', cornerPostIRI);
  };

  useEffect(() => {
    const tempArray = [];
    setCornerPostsArray([]);

    cornerPosts['hydra:member']?.forEach((product) => (
      tempArray.push((
        {
          description: product.description,
          compare: product['@id'],
          iri: product['@id'],
          value: product.productGroup.number,
        }))));

    setCornerPostsArray(tempArray);
  }, [cornerPosts]);

  useEffect(() => () => setInputDataToSend('cornerPostIRI', undefined), []);

  return (
    <>
      <Autocomplete
        autoHighlight
        className={classes.posts}
        getOptionLabel={(option) => option.description}
        disableClearable
        options={cornerPostsArray}
        value={selectedOption}
        onChange={(_, value) => handleCornerPostSelectChange(value)}
        renderInput={(params) => (
          <TextField
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...params}
            label="Corner Posts"
            color="secondary"
            variant="standard"
            error={getIsError('doublePost', validation.form)}
            helperText={getErrorMessage('doublePost', validation.form)}
          />
        )}
      />
    </>
  );
}

CornerPostSection.propTypes = {
  fetchProductsBySection: PropTypes.func.isRequired,
  inputData: inputDataCustom.isRequired,
  cornerPosts: PropTypes.objectOf(PropTypes.any).isRequired,
  setInputDataToSend: PropTypes.func.isRequired,
  validation: PropTypes.shape({
    form: PropTypes.arrayOf(PropTypes.any),
  }).isRequired,
};
